import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useRouteSession } from '@web/app'
import { ROUTES, isSafeRedirectPath } from '@web/router'

export function authDestination(pathname: string, search: string): string {
	const requested = new URLSearchParams(search).get('redirect')
	if (requested !== null && isSafeRedirectPath(requested)) return requested
	return pathname === ROUTES.signUp ? ROUTES.onboardingName : ROUTES.getStarted
}
export function AuthLayout() {
	const { state } = useRouteSession()
	const { pathname, search } = useLocation()

	if (state.status === 'ready') return <Navigate to={authDestination(pathname, search)} replace />
	if (state.status === 'organisation') {
		return <Navigate to={state.displayName === null ? ROUTES.onboardingName : ROUTES.chooseOrganisation} replace />
	}
	if (state.status !== 'anonymous') return null
	return <Outlet />
}
